import kyc from 'src/circuits/taxation-circuit/steps/kyc/locales/kyc'
import currentSituation from './current-situation'
import financialInvestment from './financial-investment'
import investmentConfiguration from './investment-configuration'
import leversSelection from './levers-selection'
import realEstateInvestment from './real-estate-investment'
import synthesis from './synthesis'

export default {
  currentSituation,
  kyc,
  investmentConfiguration,
  financialInvestment,
  leversSelection,
  realEstateInvestment,
  synthesis
}
